var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcChange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17856 14.522L6.17856 3.83597L8.51367 6.17278C8.82989 6.48922 9.34069 6.48922 9.65691 6.17278C9.97312 5.85634 9.97312 5.34516 9.65691 5.02872L5.93532 1.30442C5.61911 0.987976 5.1083 0.987976 4.79209 1.30442L1.0705 5.02872C0.75429 5.34516 0.75429 5.85634 1.0705 6.17278C1.38672 6.48922 1.89752 6.48922 2.21373 6.17278L4.55695 3.83597L4.55696 14.522C4.55696 14.9683 4.92182 15.3334 5.36776 15.3334C5.8137 15.3334 6.17856 14.9683 6.17856 14.522Z",
    fill: "#0066DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8215 1.47814V12.1642L11.4863 9.82738C11.1701 9.51094 10.6593 9.51094 10.3431 9.82738C10.0269 10.1438 10.0269 10.655 10.3431 10.9714L14.0647 14.6957C14.3809 15.0122 14.8917 15.0122 15.2079 14.6957L18.9295 10.9714C19.2457 10.655 19.2457 10.1438 18.9295 9.82738C18.6133 9.51094 18.1025 9.51094 17.7863 9.82738L15.4431 12.1642L15.4431 1.47814C15.4431 1.03188 15.0782 0.666748 14.6323 0.666748C14.1863 0.666748 13.8215 1.03188 13.8215 1.47814Z",
    fill: "#0066DA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChange);
export default __webpack_public_path__ + "static/media/ic_change.4aa83469.svg";
export { ForwardRef as ReactComponent };